import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Message } from "semantic-ui-react";

interface IEmptyMessage extends WithTranslation {
    //
}

class EmptyMessage extends React.Component<IEmptyMessage, any> {
    public render() {
        const { t } = this.props;
        return (
            <Message

                header={t("EmptyTableRow.noResult")}
                content={t("EmptyTableRow.PleaseTryAgain")}
            />
        );
    }
}
const styles: any = {
    messageStyle: {
        //
    },
};
export default withTranslation()(EmptyMessage);
